const updates = [
  { id: 1, comic: '我独自升级', chapter: '第178话', time: '10分钟前', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-600' },
  { id: 2, comic: '咒术回战', chapter: '第271话', time: '25分钟前', tag: '日漫', tagColor: 'bg-accent-100 text-accent-600' },
  { id: 3, comic: '全知读者视角', chapter: '第210话', time: '1小时前', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-600' },
  { id: 4, comic: '剑尊归来', chapter: '第142话', time: '2小时前', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-600' },
  { id: 5, comic: '间谍过家家', chapter: '第98话', time: '3小时前', tag: '日漫', tagColor: 'bg-accent-100 text-accent-600' },
  { id: 6, comic: '某天成为公主', chapter: '第125话', time: '5小时前', tag: '韩漫', tagColor: 'bg-primary-100 text-primary-600' },
  { id: 7, comic: '怪兽8号', chapter: '第116话', time: '6小时前', tag: '日漫', tagColor: 'bg-accent-100 text-accent-600' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">更新快讯</h2>
          <p className="mt-2 text-sm text-foreground-500">实时追踪最新漫画更新，第一时间掌握动态</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updates.map((item, idx) => (
            <div key={item.id} className="relative flex items-start gap-4 pb-5 last:pb-0">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 ${idx === 0 ? 'bg-primary-500 ring-4 ring-primary-100' : 'bg-foreground-300'}`}></div>
                {idx < updates.length - 1 && <div className="w-px flex-1 bg-foreground-200 mt-1"></div>}
              </div>
              <a href="#cards" className="flex-1 min-w-0 bg-background-50 rounded-xl p-4 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer block">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900">{item.comic}</h3>
                <p className="text-xs text-primary-500 mt-1">{item.chapter} 更新</p>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="#cards" className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-200 text-foreground-600 text-sm font-medium rounded-full hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
            查看全部更新 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}